import m from "../../es2015/themes/material";
window.am4themes_material = m;


//////////////////
// WEBPACK FOOTER
// ./themes/material.js
// module id = null
// module chunks = 